export default __webpack_public_path__ + "static/media/back_to_school_loan_2023.cb1492f6.png";